import Backbone from "../../libs/backbone/backbone";
import GenericModel from "./generic.model.ts";

export default GenericModel.extend(
{
    urlRoot : 'rest/api/admin/logins',
    id : null,
    name : "",
    lastName: "",
    userName: "",
    hasActiveToken : "",
    venueName : "",
    organizationName : "",
    venueId : null,
    organizationId : null,
});

